import { LanguageContext } from 'contexts/LanguageContext';
import { Bitrix24Consumer } from 'contexts/legacy/Bitrix24Context';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import React, { useContext } from 'react';

function BillingView({ bitrix24, number }: any) {
  const params = {
    domain: bitrix24.domain,
    language: useContext(LanguageContext).userLanguage,
    auth: bitrix24.infos.auth,
    access_token: number.b24_access_token,
    userBitrixId: number.user ? number.user.ID : null,
    isAdmin: bitrix24.isAdmin,
  };

  return (
    <iframe
      src={`${process.env.REACT_APP_BILLING_VIEW_URL}?${new URLSearchParams(
        params,
      ).toString()}`}
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        margin: 0,
        padding: 0,
        position: 'fixed',
      }}
    ></iframe>
  );
}

export default Bitrix24Consumer(NumberConsumer(BillingView));
